import { IRootState, RootState } from '../root-state.store';
// @ts-ignore
import { ITicketService, TicketService } from '@/services';
import { ActivityStatus, TicketCharacters } from '../../common/enums';
import { ITicket, TicketDto, ITicketListingViewModel, ITicketChannel, ITicketParameter, TicketParameter } from '../../models/ticket';
import { Pagination } from '../../models/generic';
import { IAppointmentListingViewModel } from '../../models/appointment';
import { TICKET_LOADERS } from './ticket-types.store';

export interface ITicketState extends IRootState<ITicketService> {
  ticket?: ITicket;
  recordActivity: ActivityStatus;
  ticketParameter?: ITicketParameter;
  ticketSidebarParameter?: ITicketParameter;
  tickets?: ITicketListingViewModel[] | null;
  sideBarTickets?: ITicketListingViewModel[] | null;
  currentTicket?: ITicketListingViewModel | null;
  currentChannel?: ITicketChannel | null;
  currentTicketId?: number | null;
  currentChannelId?: number | null;
  message: any[];
  actionLoading?: ActivityStatus;
  attachmentsInQueue: any[];
  pagination: any;
  needKeep: boolean;
  characterProblems?: {
    level_1: any[];
    level_2: any[];
  };
  ticketClosureReasons?: { id: number, name: string }[];
  ticketClosureReasonsActivityStatus?: ActivityStatus;
  ticketReasons?: { id: number, name: string }[];
  ticketReasonsActivityStatus?: ActivityStatus;
  appointments?: IAppointmentListingViewModel[];
  ticketIndependentContractors?: any[];
  ticketPriorityLevels?: any[];
  ticketSubstatus?: any[];
  ticketProblemType?: any[];
  equipments?: any[];
}

export class TicketState extends RootState implements ITicketState {
  /**
   *
   */
  ticket?: ITicket;
  tickets: ITicketListingViewModel[] | null;
  sideBarTickets: ITicketListingViewModel[] | null;
  currentTicket: ITicketListingViewModel | null;
  currentChannel: ITicketChannel | null;
  currentTicketId?: number | null;
  currentChannelId?: number | null;
  ticketParameter?: ITicketParameter;
  ticketSidebarParameter?: ITicketParameter;
  message: any[];
  actionLoading?: ActivityStatus;
  attachmentsInQueue: any[];
  recordActivity: ActivityStatus;
  pagination: any;
  needKeep: boolean;
  characterProblems?: {
    level_1: any[]
    level_2: any[]
  };
  ticketClosureReasons?: { id: number, name: string }[];
  ticketReasons?: { id: number, name: string }[];
  ticketClosureReasonsActivityStatus?: ActivityStatus;
  ticketReasonsActivityStatus?: ActivityStatus;
  appointments?: IAppointmentListingViewModel[];
  ticketIndependentContractors?: any[];
  ticketPriorityLevels?: any[];
  ticketSubstatus?: any[];
  ticketProblemType?: any[];
  equipments?: any[];
  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity, service: new TicketService() });
    this.recordActivity = ActivityStatus.NoActivity;
    this.ticket = new TicketDto({
      fk_ticket_character_problem: null,
      origin_demand: 'call',
      pb_type: 'public',
      mandates: [],
      quotes: [],
      //creator: null,
      declarant: null,
      managers: [],
      channels: [],
      owners: [],
      participants: [],
      managers_assigned: [],
      apartments: [],
      force_external_apartment: false,
      fk_ticket_priority : null,
      fk_ticket_substatus : null,
    });
    this.ticketParameter = new TicketParameter({ state: [], key: null, $limit: 10 });
    this.ticketSidebarParameter = new TicketParameter({ state: [], key: null, $limit: 10 });
    this.tickets = null;
    this.sideBarTickets = null;
    this.currentTicket = {
      block: {},
      fk_ticket_character_problem: null,
      managers: [],
      //creator: []
      declarant: []
    };
    this.message = null;
    this.currentChannel = {
      actions: []
    };
    this.actionLoading = ActivityStatus.NoActivity;
    this.attachmentsInQueue = [];
    this.pagination = new Pagination({ total: 0, limit: 10, skip: 0 });
    this.needKeep = false;
    this.characterProblems = {
      level_1: [],
      level_2: [],
    };
    this.ticketClosureReasons = [];
    this.ticketReasons = [];
    this.ticketClosureReasonsActivityStatus = ActivityStatus.NoActivity;
    this.ticketReasonsActivityStatus = ActivityStatus.NoActivity;
    this.appointments = [];
    this.ticketIndependentContractors = [];
    this.loaders= new Map([
      [TICKET_LOADERS.LIST,false],
      [TICKET_LOADERS.LIST_FILTERS,false],
      [TICKET_LOADERS.SIDEBAR,false],
      [TICKET_LOADERS.CHAT_HEADER,false],
      [TICKET_LOADERS.CHAT_CONTENT,false],
      [TICKET_LOADERS.CHAT_EDITOR,false]
    ])
    this.ticketPriorityLevels = []
    this.ticketSubstatus = []
    this.ticketProblemType =  []
    this.equipments = []
  }
}



// WEBPACK FOOTER //
// ./src/store/ticket/ticket-state.store.ts